import React, { Component } from 'react';
import { Route, HashRouter as Router, Redirect, Switch } from 'react-router-dom';
import './App.css';
import Login from './container/login';
import Observer from './applications/stores/observer';
import { Util } from './common/util';

export default class App extends Component {
    /**
     *  进入页面加载一次
     */
    componentWillMount(e) {
        let hrefParams = window.location.href;
        let obj = Util.handleUrl(hrefParams);
        if(JSON.stringify(obj) != '{}'){
            Observer.platformType = (obj.platformType && !isNaN(obj.platformType))?obj.platformType:1;
            if(isNaN(obj.isTab)) obj = Util.handleUrl(hrefParams,-2);
            Observer.isTab = (obj.isTab && !isNaN(obj.isTab)) ? obj.isTab : 2;
        }
    }
    render() {
        return (
            <Router>
                <Switch>
                    <Route exact path="/" component={Login} />
                    <Route exact path="/login" component={Login} />
                    <Route exact path="*" component={Login} />
                </Switch>
            </Router>
        );

    }
}




// WEBPACK FOOTER //
// ./src/App.js